import { useState } from "react"
import axios from 'axios'
import '../css/Contact.css'


const OPTIONS = {
    method: "POST",
    url: process.env.REACT_APP_APP_URL || "http://localhost:5000/contact",
    maxBodyLength: Infinity,
    headers: {
        "Content-Type": "application/json"
    },
    data: {}
}


const popupStyle = {
    marginBottom: '10px', // Add space between the message and submit button
    padding: '10px',
    backgroundColor: 'green',
    color: 'white',
    borderRadius: '5px',
    textAlign: 'center'
};

const Contact = () => {

    const [formData, setFormData] = useState({ name: '', phone: '', email: '' })
    const [submitMessage, setSubmitMessage] = useState(false)

    const handleChange = (e) => {
        console.log('event', e)
        const { name, value } = e.target
        console.log('name', name, value)
        setFormData({ ...formData, [name]: value })

    }

    const handleSubmit = async (e) => {
        try {
            e.preventDefault()

            OPTIONS.data = formData
            console.log('options====================>', OPTIONS)
            const result = await axios(OPTIONS)
            console.log('result', result)
            if (result?.data.data.status) {
                console.log('conact submited')
                setSubmitMessage(true)
                setTimeout(() => {
                    setSubmitMessage(false)
                }, 2000)
                setFormData({ phone: '', email: '', name: '' })
                console.log('submitMessage', submitMessage)
            }

            console.log('formData', submitMessage, formData)
        } catch (error) {
            console.log('error===========>', error)
        }

    }
    return (
        <section className="contact">
            <h2> If you want to build your own Application Fill below details, I will reach out to you soon... </h2>
            <div onSubmit={handleSubmit} className="contactDetails">
                <form className="contactForm">
                    {submitMessage && <p style={popupStyle}>Successfuly submitted!</p>}
                    <label htmlFor="name"> Name  </label>
                    <input id='name' type="text" name="name" placeholder="Enter your Name" onChange={handleChange} value={formData.name} required></input> <br /><br />

                    <label htmlFor="phone"> Phone  </label>
                    <input id='phone' type="phone" name="phone" placeholder="Enter your phone number" onChange={handleChange} value={formData.phone} required></input> <br /><br />

                    <label htmlFor="email"> Email </label>
                    <input id='email' type="email" name="email" onChange={handleChange} placeholder="Enter your email" value={formData.email} required ></input> <br /><br />
                    <button id='contactSubmitButton' type="submit"> Submit</button>
                </form>

            </div>

        </section>
    )
}

export default Contact